exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1, h2, h3 {\n  font-family: 'Roboto', sans-serif;\n}\n\nh1 {\n  color: #3f51b5;\n}\n\nh2, h3 {\n  font-weight: 300;\n  color: rgba(0,0,0,.64);\n  white-space: pre-wrap;\n}\n\nh2 {\n  font-size: 18px;\n}\n\n\nh3 {\n  font-size: 16px;\n  margin-top: 30px;\n  margin-bottom: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/delete-confirm-dialog/delete-confirm-dialog.component.css
// module id = ../../../../../src/app/delete-confirm-dialog/delete-confirm-dialog.component.css
// module chunks = main